import type { ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth.store'
import { ROUTES } from '@/config/routes.config'

// Application route guard for authenticated workspace routes.
export default function RequireAuth({ children }: { children?: ReactNode }) {
  const token = useAuthStore((s) => s.token)
  const user = useAuthStore((s) => s.user)
  const location = useLocation()
  if (!token || !user) {
    return <Navigate to={ROUTES.login} state={{ from: `${location.pathname}${location.search}${location.hash}` }} replace />
  }

  return children ?? <Outlet />
}
